import { Dispatch } from 'redux';

import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { eventFlowError, eventFlowHeartbeat, eventFlowUpdate } from '../actions';

export const asyncEventUpdate = (event: 'page-view' | 'order-now-click' | 'total-view' | 'checkout-complete' | 'quantity-increase' | 'quantity-decrease' | 'discount-applied' | 'page-exit' | 'add-to-cart') => {
  return async (dispatch: Dispatch<any>, getState: () => ReduxState) => {
    const { eventFlow } = getState().events;
    const { user } = getState().user;
    const selectedPage = getState().page.selectedPage;
    let userId = eventFlow.userId;
    let businessId = eventFlow.businessId;
    let itemId = eventFlow.itemId;
    
    if (user) userId = user._id;
    if (selectedPage && selectedPage.associatedBusinesses && selectedPage.associatedBusinesses.length > 0) {
      businessId = selectedPage.associatedBusinesses[0]._id;
      itemId = selectedPage._id
    }
    const eventUpdate = {
      ...eventFlow,
      event,
      userId,
      businessId,
      itemId
    }
    try {
      const response = await backend.post('/marketplace-service/api/v1/market-events', eventUpdate);
      if (response.status === 200 || response.status === 201) {
        dispatch(eventFlowUpdate(response.data));
        const timestamp = new Date()
        dispatch(eventFlowHeartbeat(timestamp.getTime()));
      } else {
        dispatch(eventFlowError(`Error communicating with server`));
      }
    } catch (error) {
      console.error('Error communicating with server:', error);
      dispatch(eventFlowError(`Error communicating with server`));
    }
  };
};